import { gql } from '@apollo/client';

export const REWARD_COMMUNITY_SETTINGS_POINTS_PER_ACTION_FRAGMENT = gql`
  fragment RewardCommunitySettingsPointsPerAction on RewardCommunitySettingsPointsPerAction {
    action
    points
  }
`;
